import styles from './Navbar.module.css';
import { useMoralis } from "react-moralis";
import { Link } from "react-router-dom";

function Navbar() {


    const { authenticate, isAuthenticated, user } = useMoralis();

    return (
        <div className={styles["navbar-wrapper"]}>
            <Link to="/">
            <div className={styles.logo}>
                WM
            </div>
            </Link>
            

            {isAuthenticated

            &&
            
            <h3 className={styles.username}>User : {user.get("username")}</h3>
            
            }

            
        </div>
    )
}

export default Navbar
